module.exports = __webpack_public_path__ + "img/cloth_g1_item_01.7a04e423.svg";